import {get} from '@/request/utils'

export default {
  resBdData(res) {
    return get(res, 'res.bd.data', {})
  },
  resBdDataBd(res) {
    return get(res, 'res.bd.data.bd', {})
  },
  dataResHd(res) {
    return get(res, 'data.res.hd', {})
  },
  dataResHdCode(res) {
    return get(res, 'data.res.hd.code', false)
  }
}



// WEBPACK FOOTER //
// ./src/utils/responseHandler.js